import Button from './Button';
import Modal from './Modal';
import { Cluster, Box } from './layouts';
import {useTranslation} from "react-i18next";

const ConfirmModal = ({ isOpen, title, text, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      showCloseButton={false}
      width="440px"
      showProgressBar
      progressBarColor="alert"
    >
      <Box fontScale="xl" fontWeight="bold">
        {title}
      </Box>
      <Box pt="m">{text}</Box>
      <Cluster mt="xl" display="flex" justifyContent="flex-end" hGap="m">
        <Button variant="alert-outline" onClick={onCancel}>
          {t('Annuleren')}
        </Button>
        <Button variant="alert" onClick={onConfirm}>
          {t('Verwijderen')}
        </Button>
      </Cluster>
    </Modal>
  );
};

export default ConfirmModal;
